<template>
  <div :class="['protocol-container',isMobile?'mobile':'',isMinip?'minip':'']">
    <div class="protocol">
      <p class="title">魔音工坊自动续费服务协议</p>
      <!-- <div class="update-data">更新日期：2022年03月11日</div> -->
       <div class="update-data">
          <p class="time compact">发布日期：【2024】年【05】月【13】日</p>
          <p class="time compact">生效日期：【2024】年【05】月【13】日</p>
        </div>
      <div class="container">
        <p>尊敬的用户：为了给您提供更便捷、高效的服务，魔音工坊推出了自动续费服务（以下简称“本服务”）。<span class="highlight">在使用本服务前，请您务必审慎阅读，充分理解各条款内容。特别是免除或者限制责任的条款、争议解决和法律适用条款。</span></p>
        <p>
          当您选择使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。<span class="highlight">您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容或者未获得我们对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</span>
        </p>
        <p>
          请您注意，我们可能会不时检查并更新本协议，因此有关本协议的内容会随之变化。如果您继续使用本服务，即视为您已充分理解并同意我们对本协议的更新修改。如果您不接受我们对本协议的更新修改，应立即停止开通或使用本服务。
        </p>
        <p>
        <p class="title">一、缔约主体</p>
        <p>
          本协议由您与北京小问智能科技有限公司（注册地为【北京市海淀区高梁桥斜街42号院1号楼7层1-729】）及所有关联公司 (以下简称“我们”、“公司”）共同缔结，本协议对您与我们均有合同效力。
        </p>
        <p class="title">二、定义</p>
        <p>
          本服务：也即“自动续费服务”，是指您在购买魔音工坊的付费服务后，为避免您因疏忽或其它原因导致未能及时续费而推出的服务。若您选择开启自动续费功能，则意味着您授权我们可在您的付费服务自动续费期限到期前24小时或到期后，从您相应的支付账户中进行自动扣款，为您续订下一期的付费服务，下一期付费服务有效期自当期服务期满后自动续展。
        </p>
        <p class="title">三、本协议的内容和确认</p>
        <p>
          本协议包括本协议正文及所有本服务已经发布或将来可能发布的《魔音工坊用户协议》、《魔音工坊隐私政策》、各项政策、规则声明、通知、警示、提示、说明（以下统称“服务协议及规则”）。前述规则为本协议不可分割的组成部分，与本协议具有同等法律效力。本协议未尽事宜，以前述服务协议及规则为准。
        </p>
        <p class="title highlight">四、服务开通</p>
        <p>
          1、基于自动续费功能的服务提供，<span class="highlight">您同意在开通或使用本服务时，授权公司可在您当期付费服务即将过期时或到期后，委托运营商或支付渠道（如微信、支付宝等）扣除下一期付费服务的费用，费用扣除成功后，将为您自动延长相应付费服务的服务期限。如因您账户余额不足或其它原因导致续费失败的，您应自行承担相关责任。</span>
        </p>
        <p>
          2、您理解并同意：
        </p>
        <p>
         （1）开通本服务并不代表您一定可以续费成功。
        </p>
        <p>
         （2）<span class="highlight">公司有权调整付费服务（包括自动续费服务）的价格，</span>在本服务有效期内，如公司对您开通本服务时的服务价格作出调整，将会通过站内信的方式通知您。如您不同意，您可以按本协议第六条的约定取消本服务，则您的付费服务期限自当前付费服务周期届满日即终止，<span class="highlight">如您未取消本服务的，则视为您同意按照调整后的服务价格扣除下一期付费服务的费用。</span>
        </p>
        <p >
         （3）开通本服务不收取任何手续费，但公司有权根据业务实际情况决定是否收取费用或调整本服务的周期及费用。
        </p>
        <p class="title">五、服务说明</p>
        <p>1、计费周期</p>
        <p>魔音工坊提供月度计费周期，您可以根据自身需求进行选择。</p>
        <p>2、扣费规则</p>
        <p>
          （1）您在开通本服务时，已明确知晓并同意付费服务的计费标准和支付方式。公司将在您的付费服务到期前，按照当时的计费标准和支付方式进行自动扣款。您同意公司及运营商、支付渠道可在无验证、校验等信息的情况下直接从用户相应账户中扣除下一期付费服务的费用。若您在付费服务到期前修改了支付账户或支付方式，公司将自动使用您最新的支付信息进行扣款。
        </p>
        <p>
          （2）<span class="highlight">除非您主动或者公司取消了自动续费，否则，公司将按照本协议自动扣费及续订相应付费服务，且长期有效、不受次数限制；同时，如您未主动取消自动续费，视为您同意公司在付费服务期限到期后的一定期限内不时进行扣款操作，扣款成功后，将为您开通相应付费服务的服务期限。</span>
        </p>
        <p>
          （3）我们将于您当期付费服务期限届满前5日以站内信的方式向您发送自动续费提示，请您保持关注，以便及时了解付费服务状态。在该提示到达您后，如您未取消本服务，则您同意我们按照本协议约定扣除下一期付费服务的费用。
        </p>
        <p>3、<span class="highlight">您理解并同意，当您选择使用本服务时，公司按照本协议约定成功扣除下一期付费服务的费用时，视为您同意购买相应付费服务，公司不支持该付费服务的退款请求。</span></p>

        <p class="title">六、服务终止</p>
        <p>
          1、您可以主动选择取消本服务，取消方式如下：
        </p>
        <p>
          （1）苹果移动设备端：魔音工坊APP-->点击“我的”-->点击“设置”-->点击“续费管理”-->点击“关闭续费”-->点击“确认”。
        </p>
        <p>
          （2）安卓移动设备端：魔音工坊APP-->点击“我的”-->点击“设置”-->点击“续费管理”-->点击“关闭续费”-->点击“确认”。
        </p>
        <p>
          （3）电脑网页端：点击“头像”-->“续费管理”-->点击“关闭续费”-->点击“确认”。
        </p>
        <p>
          一旦您取消自动本服务，您相应的付费服务将在到期后停止，如需继续使用，您需手动重新购买。
        </p>
        <p>
          2、我们将为您提供便捷的自动续费管理服务。您可以通过魔音工坊平台随时查看、取消您的自动续费状态。
        </p>
        <p>
          3、您知悉并同意
        </p>
        <p>
            （1）您通过本条第1款方式取消本服务后，相应付费服务到期后将不再自动续费。<span class="highlight">但此前您授权魔音工坊进行的自动续费及扣款行为仍然有效，魔音工坊对前述扣款费用不予退还。</span>
        </p>
        <p>
            （2）<span class="highlight">因受支付渠道扣款规则限制，如您在当前自动续费服务计费周期到期前24小时内取消的，则支付渠道可能会按照当时的服务价格扣除下一个计费周期的服务费用后停止代扣服务，扣款成功的，则您的付费服务期限自下一个计费周期届满之日起终止。</span>
        </p>
        <p>
          4、<span class="highlight">如您违反相关法律法规、本协议及服务协议及规则，公司有权进行独立判断并根据相关法律法规、本协议或服务协议及规则选择中止或终止本服务，由此给您带来的损失应由您自行承担，如给公司造成损失的，您应予赔偿。</span>
        </p>
        <p class="title">七、其他</p>
        <p>
          1、关联公司：系指北京小问智能科技有限公司在中国地区的关联公司，包括但不限于出门问问创新科技有限公司、北京小问智能科技有限公司，上海羽扇智信息科技有限公司、北京羽扇智信息科技有限公司、问问智能信息科技有限公司、武汉问问智能信息科技有限公司、深圳问问智能信息科技有限公司、出门问问信息科技有限公司、出门问问（武汉）信息科技有限公司、出门问问（苏州）信息科技有限公司、深圳小问智能科技有限公司、南京小问智能科技有限公司。
        </p>
        <p>
          2、如您对本协议或使用我们的服务相关的事宜有任何问题（包括问题咨询、投诉等），请通过moyin-complaint@mobvoi.com邮箱与我们联系，我们会在收到您的意见及建议后尽快向您回复。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile:false,
      isMinip:false
    }
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      this.isMobile = flag
    }
  },
  mounted() {
    this.isMobile = this.checkIsMobile()
   let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger')!=-1 || ua.indexOf('miniProgram')!=-1) {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
     this.isMinip = true;
    }
    if(this.isMobile){
     document.title="魔音工坊";
    }
  }
}
</script>

<style lang="less" scoped>
.protocol-container{
  font-size: 16px;
  width: 100%;
  overflow: auto;
  height: 100vh;
  background: #fff;
  color: #1f2329 !important;
  .highlight {
    font-weight: 800;
  }

  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    margin: 20px auto;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
    .title {
      width: 100%;
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
    }
    .update-data {
      padding: 12px 0;
      text-align: center;
      .time{
        font-size: 16px;
        font-weight: 800;
        text-align: left;
      }
    }
    .container {
      margin-top: 20px;
      .title {
        font-size: 16px;
        margin-top: 32px;
        font-weight: 800;
        text-align: left;
      }
      .time {
        text-align: left;
      }
      p {
        margin-bottom: 20px;
        .highlight {
          font-weight: 800;
        }
        a {
          color: #5a92f4;
        }
        &.compact{
          margin-bottom:0px
        }
        &.flex{
          display:flex;
          >span:nth-child(2){
            margin-left: 1em;
          }
        }
        .q{
          margin-left: 1em;
        }
      }
      .update-data{
        .time{
          font-weight:800;
        }
        p{
          font-weight: 800;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}
// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}
@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}
.protocol-container {
  &.mobile:not(.minip){
    .protocol {
      min-width: auto;
      max-width: none;
      border-radius: 4rpx;
      height: auto;
      box-sizing: border-box;
      padding: 0;
      margin: 20rpx auto !important;
      background: #fff;
      box-shadow: 0px 0px 11rpx 0px rgba(63, 95, 150, 0.04);
      .title {
        width: 100%;
        margin: 36rpx 0 22px;
        text-align: center;
        font-size: 34rpx;
        font-weight: 500;
        color: #1f2329;
      }
      .update-data {
        padding: 12rpx 0;
        text-align: center;
      }
      .container {
        margin-top: 20rpx;
          .title {
            font-size: 16rpx;
            margin-top: 32rpx;
            font-weight: 800;
            text-align: left;
          }
          .time {
            text-align: left;
          }
          p {
            margin-bottom: 20rpx;
            .highlight {
              font-weight: 800;
            }
            a {
              color: #5a92f4;
            }
            &.compact{
              margin-bottom:0px
            }
            &.flex{
              display:flex;
              >span:nth-child(2){
                margin-left: 1em;
              }
            }
            .q{
              margin-left: 1em;
            }
          }
          .update-data{
            .time{
              font-weight:800;
            }
            p{
              font-weight: 800;
            }
          }
      }
    }
  }
  &.mobile{
    &.minip{
      .protocol {
        min-width: auto;
        max-width: none;
        margin:0 auto;
        width:100%;
        font-size:3.4rem;
        .title {
          font-size: 3.4rem;
        }
        .update-data {
          font-size:1.6rem;
        }
        .container {
          font-size:1.9rem;
          .title {
            font-size: 2rem;
          }
          &.flex{
            display:flex;
            >span:nth-child(2){
              margin-left: 1rem;
            }
          }
          .q{
            margin-left: 1rem;
          }
        }
      }
    }
  }
}
</style>
